import React from "react";

type Option = {
  label: string;
  value: number|boolean;
};

type OptionSetProps = {
  options: Option[];
  value: number|boolean;
  onChange: (value: number|boolean) => void;
  name?: string; // to group radios correctly
  className?: string;
};

export const OptionSet: React.FC<OptionSetProps> = ({ options, value, onChange, name = "option-set", className = "" }) => {
  return (
    <div className={`flex ${className}`}>
      {options.map((option) => (
        <label key={String(option.value)} className="flex items-center gap-1 cursor-pointer m-0">
          <input
            type="radio"
            name={name}
            value={String(option.value)}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
            className="accent-blue-600"
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </div>
  );
};
